import React from 'react';
import {
  Box,
  Tooltip,
} from '@mui/material';
import { useThemeStatics } from '../../hooks/useThemeConfig';

function Logo({ sx }) {
  const staticConfig = useThemeStatics();
	const { homeUrl, imageFromHomeUrl, logo, clientName } = staticConfig;
  const logoUrl = (imageFromHomeUrl ? homeUrl : '') + logo;
  const handleGoToMainSite = () => {
    window.location.assign(homeUrl);
  };
  return (
    <Tooltip title={'Ir al sitio de ' + clientName} placement="bottom-end">
      <Box
        component="img"
        sx={sx}
        alt="Logo image"
        src={logoUrl}
        onClick={handleGoToMainSite}
      />
    </Tooltip>
  );
}

export default Logo;